
<section class="storyblok-blok-container">
  <div class="products-catalog" appDisableClickEvent>
    <div fxLayout="column">
      <app-shared-catalog-products-list
        [searchQuery]="categoryProps.searchQuery"
        [products]="categoryProps.products"
        [totalCount]="categoryProps.productsTotalCount"
        [recommendedProducts]="categoryProps.recommendedProducts"
        [recommendedProductsType]="categoryProps.recommendedProductsType"
        [isCategoryPage]="true"
        [selectedCategory]="selectedCategory$ | async"
        [queryParams]="categoryProps.queryParams"
        [isMobileOrTablet]="categoryProps.isMobileOrTablet"
        [isDesktop]="categoryProps.isDesktop"
        [isMobile]="categoryProps.isMobile"
        [isZeroResult]="categoryProps.isZeroResult"
        [hasFilters]="categoryProps.hasFilters"
        [isExpired]="categoryProps.isExpired"
        [isTablet]="categoryProps.isTablet"
        [hidePageTitle]="hidePageTitle"
      >
        <div class="catalog-content">
          <app-storyblok-seo-content-wrapper
            *ngIf="!!catalogSeoContent"
            [content]="catalogSeoContent['content']"
            [_editable]="catalogSeoContent['_editable']"
            [isMobile]="isMobile"
          ></app-storyblok-seo-content-wrapper>
        </div>
      </app-shared-catalog-products-list>
    </div>
  </div>

</section>
